.root {
  font-weight: 400;
  text-transform: uppercase;

  &[data-variant="light"] {
    background-color: light-dark(var(--ti-bg), var(--mantine-color-primaryDark-7));
  }
}